import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useAuth0 } from '@auth0/auth0-react';
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { useLogout } from '@/contexts/LogoutContext';
import { getSafeReturnUrl } from '@/utils/redirectUrl';
import { Box, CircularProgress } from '@mui/material';
import { LoginContainer } from '../../components/index.jsx';
import './Login.scss';

export const Login = () => {
	const history = useHistory();
	const location = useLocation();
	const isAuthenticated = useIsAuthenticated();
	const { isLoggingOut } = useLogout();
	const { isLoading: auth0IsLoading } = useAuth0();
	const [isCheckingAuth, setIsCheckingAuth] = useState(true);

	// Guard: If user is already authenticated, prefer return_url over dumping on /home.
	// prompt=login forces Universal Login even when a session already exists.
	useEffect(() => {
		if (auth0IsLoading) {
			return;
		}

		if (isLoggingOut) {
			return;
		}

		const params = queryString.parse(location.search);
		const forcePromptLogin = params.prompt === 'login';
		const safeReturnUrl = getSafeReturnUrl(params.return_url);

		if (isAuthenticated && !forcePromptLogin) {
			history.replace(safeReturnUrl || '/home');
			return;
		}

		setIsCheckingAuth(false);
	}, [history, isAuthenticated, auth0IsLoading, isLoggingOut, location.search]);

	// Show loading spinner while checking authentication to prevent flash of login page
	if (isCheckingAuth) {
		return (
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '100vh',
					width: '100vw',
					backgroundColor: 'white'
				}}
				data-testid="loginView"
			>
				<CircularProgress size={40} />
			</Box>
		);
	}

	return (
		<div className="loginContainer" data-testid="loginView">
			<LoginContainer />
		</div>
	);
};

export default Login;
